import { t } from 'i18next';
import { UseFormSetError, FieldValues } from 'react-hook-form';
import { hasCharsForNames, hasOnlyNumbers } from 'utils/string';
import { INPUT_NAMES } from './inputNames';

export const validationHandler = (
  setError: UseFormSetError<FieldValues>,
  value: string,
  inputName: string,
): boolean => {
  if (!value) {
    setError(inputName, {
      message: String(t(`purchase.formInputs.formErrors.${inputName}.empty`)),
    });
    return true;
  }
  if (inputName === INPUT_NAMES.CARD_HOLDER && !hasCharsForNames(value)) {
    setError(inputName, {
      message: String(t(`purchase.formInputs.formErrors.${inputName}.wrong`)),
    });
    return true;
  }
  if (
    inputName === INPUT_NAMES.ZIP_CODE &&
    (value.length !== 5 || !hasOnlyNumbers(value))
  ) {
    setError(inputName, {
      message: String(t(`purchase.formInputs.formErrors.${inputName}.wrong`)),
    });
    return true;
  }
  return false;
};
